import AudioTranscript from '@modules/feedback/components/AudioType/AudioTranscript/AudioTranscript';
import { Highlight } from '@modules/feedback/types';
import { CloseRounded } from '@mui/icons-material';
import { Box, IconButton, Stack } from '@mui/material';
import { Feedback, FeedbackLabel } from 'v2/core/entities/feedback';
import { AudioTranscriptButton } from './AudioTranscriptButton';

interface AudioTranscriptExpandedViewProps {
  selectedLabels?: FeedbackLabel[];
  onCollapse: () => void;
  feedback: Feedback;
  highlights: { [key: string]: Highlight[] };
  showOriginalLanguage: boolean;
}

export const AudioTranscriptExpandedView = ({
  selectedLabels,
  onCollapse,
  feedback,
  showOriginalLanguage,
  highlights,
}: AudioTranscriptExpandedViewProps) => {
  return (
    <Box>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          pl: 2,
          py: 1,
        }}
      >
        <AudioTranscriptButton onClick={onCollapse} isExpanded />
        <IconButton onClick={onCollapse} color="primary">
          <CloseRounded />
        </IconButton>
      </Stack>
      <Box
        p={2}
        sx={{
          overflowY: 'auto',
          maxHeight: '65vh',
        }}
      >
        <AudioTranscript
          feedback={feedback}
          showOriginalLanguage={showOriginalLanguage}
          highlights={highlights}
          selectedLabels={selectedLabels}
        />
      </Box>
    </Box>
  );
};
